import { Dispatch, SetStateAction } from "react";
import { PaymentMethodsTabsProps } from "pages/Quotes/SavedInMoney/interface";
import { ProductSelectedProps } from "pages/Quotes/Details/interface";
import { IQuoteDetailItem } from "models/QuoteDetailItem";
import { UpdateApprovedMapAutomaticProps } from "models/MapProduct";

export interface IDistributionCenterProps {
    quoteId: string;
    hasMore: boolean;
    className?: string;
    setShouldReset: any;
    customerCode: string;
    productSelected: any[];
    sequenceNumber: string;
    setSequenceNumber: any;
    isQuoteExpired?: boolean;
    distributionCenter: string;
    ableNegotiacionBtn: boolean;
    distributionCenterName: any;
    setIsDeparaModalDisplayed: any;
    distributionCenterSelected: string;
    handleChangeProductSelected?: () => void;
    newProductSelected: ProductSelectedProps[];
    setHasMore: Dispatch<SetStateAction<boolean>>;
    setProductSelected: Dispatch<SetStateAction<any[]>>;
    setDistributionCenterSelected: Dispatch<SetStateAction<string>>;
    modalIsOpen?: {
        isOpen: boolean;
        isCancelButtonClicked: boolean;
        firstLoad: boolean;
    };
    setQtdItemsAlreadySent: (qtdItems: number) => void;
    setRefreshControl: Dispatch<SetStateAction<boolean>>;
    setOldSegmentSelected: Dispatch<SetStateAction<string>>;
    setRemoveAllFromToSegment: Dispatch<SetStateAction<boolean>>;
    setPaymentMethods: (paymentMethods: PaymentMethodsTabsProps[]) => void;
    allBudgetsSavedInQuote?: (distributionCenterTab?: string) => Promise<void>;
    reproveMapProduct: (item: IQuoteDetailItem) => Promise<void>;
    approveMapProduct: (id: string, sequenceNumber: number, data: UpdateApprovedMapAutomaticProps) => Promise<void>;
}

export interface CdFilterProps {
    distributionCenter: string;
}

export const HeaderLabelQuotes = [
    { label: "", key: "isCustomer" },
    { label: "Item", key: "sequenceNumber" },
    { label: "Código", key: "id" },
    { label: "Descrição", key: "description" },
    { label: "", key: "tagsMedicineTipe" },
    { label: "Marca", key: "producer" },
    { label: "Qtd. Total", key: "quantity" },
    { label: "Unidade", key: "unit" },
    { label: "Conversão ", key: "conversionFactor" },
    { label: "Ações", key: "actionBtn" },
];

export interface DistributionCenterListProps {
    totalItems: number;
    negotiation: boolean;
    paymentMethod?: string;
    distributionCenter: string;
    previouslyAddedToBionexo?: boolean;
}

export interface TabsDistributionCenterListProps {
    label: string;
    negotiation: boolean;
    trackingName: string;
    previouslyAddedToBionexo?: boolean;
    filter: { distributionCenter: string; };
}